import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { ChainHealthComponent } from '@app/features/chain-health/modules/chain-health/chain-health.component';
import { ChainWideMerakisModule } from '@app/features/merakis/modules/chain-wide-merakis/chain-wide-merakis.module';
import { ChainWideFortigatesModule } from '@app/features/fortigates/modules/chain-wide-fortigates/chain-wide-fortigates.module';
import { ChainWideCradlepointsModule } from '@app/features/cradlepoints/modules/chain-wide-cradlepoints/chain-wide-cradlepoints.module';
import { ChainWideMistsModule } from '@app/features/mists/modules/chain-wide-mists/chain-wide-mists.module';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        ChainWideMerakisModule,
        ChainWideFortigatesModule,
        ChainWideCradlepointsModule,
        ChainWideMistsModule
    ],
    declarations: [
        ChainHealthComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class ChainHealthModule {}